module.exports = __webpack_public_path__ + "img/PFishingBoat64_ua.24068a8a.webp";